import axios from 'axios';
import api, { refreshSession } from './api.js';

const logisticsApi = axios.create({
  baseURL:         import.meta.env.VITE_LOGISTICS_API_URL || '/api/logistics',
  timeout:         15000,
  withCredentials: true,
  headers:         { 'Content-Type': 'application/json' },
});

logisticsApi.interceptors.request.use((config) => {
  const authHeader = api.defaults.headers.common['Authorization'];
  if (authHeader) config.headers['Authorization'] = authHeader;
  return config;
});

logisticsApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const { data } = await refreshSession();
        original.headers['Authorization'] = `Bearer ${data.accessToken}`;
        return logisticsApi(original);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default logisticsApi;
